<app-success-layout
  class="organizer-activity-sharing-page-success"
  [desktopBackgroundImage]="desktopBackgroundImage"
  [mobileBackgroundImage]="mobileBackgroundImage"
  [title]="'activity_sharing.success.layout.title' | translate"
>
  <p>{{ 'activity_sharing.success.text' | translate }}</p>

  <div footer>
    <a
      app-vtmn-play-button
      class="w-full"
      [routerLink]="'/organizer.planning.planning' | localize"
      [variant]="vtmnPlayButtonVariant.PRIMARY"
      [style]="vtmnPlayButtonStyle.INVERSE"
    >
      {{ 'activity_sharing.footer.buttons.dashboard' | translate }}
    </a>

    <a
      app-vtmn-play-button
      class="w-full mt-3"
      [routerLink]="'/organizer.activity-creation.steps-1' | localize"
      [variant]="vtmnPlayButtonVariant.SECONDARY"
      [style]="vtmnPlayButtonStyle.INVERSE"
    >
      {{ 'activity_sharing.footer.buttons.activity_creation' | translate }}
    </a>
  </div>
</app-success-layout>
